export default "__VITE_ASSET__DQrKCsmc__"